import { useContext, useState } from "react";
import { Dropdown, DropdownSkeleton } from "carbon-components-react";
import { Label } from "../Label";
import { StatusContext } from "../../../context";

export const BabyUnusualReason = ({
  id,
  className,
  style,
  field = {},
  data,
  onChange,
}) => {
  const { babyUnusualReason } = useContext(StatusContext);
  const title = "新生兒異常原因";

  const { key, required = false } = field;
  const { type = "number" } = field.schema;
  const item = (babyUnusualReason || []).find((x) => x.id === data);
  const [shouldValidate, setShouldValidate] = useState(false);
  const invalid = shouldValidate && required && data === undefined;

  return !babyUnusualReason ? (
    <DropdownSkeleton id={id} className={className} style={style} />
  ) : (
    <Dropdown
      id={id}
      className={className}
      style={style}
      titleText={<Label required={required}>{title}</Label>}
      label="請選擇"
      items={babyUnusualReason}
      itemToString={(item) => (item ? item.name : "")}
      selectedItem={item}
      invalid={invalid}
      invalidText="此為必填欄位"
      onFocus={() => setShouldValidate(false)}
      onBlur={() => setShouldValidate(true)}
      onChange={(e) => {
        let v = e.selectedItem.id;
        if (type === "number") {
          v = +v;
        }
        if (typeof onChange !== "function") return;
        onChange({ [key]: v });
      }}
    />
  );
};
